import React from 'react';
import './MobileLayout.css';

interface MobileLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({ children, className = '' }) => {
  return (
    <div>
        {children}
    </div>
  );
};

export default MobileLayout;
